import { Component, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormControl, Validators, ValidatorFn } from "@angular/forms";
import { SharedService } from "../shared/service";
import { AccountHttpService } from "../generated/account-http.service";
import { HttpErrorResponse } from "@angular/common/http";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";

function matchValidator(targetKey: string, toMatchKey: string): ValidatorFn {
  return (group: FormGroup) => {
    const target = group.controls[targetKey];
    const toMatch = group.controls[toMatchKey];

    if (target.value !== toMatch.value) {
      target.setErrors({ match: true });
    } else {
      target.setErrors(null);
    }

    return null;
  };
}

@Component({
  templateUrl: './password.content.html'
})
export class PasswordContent {

  @ViewChild('password') private elementRef: ElementRef;

  public ngAfterViewInit(): void {
    this.elementRef.nativeElement.focus();
  }

  form = new FormGroup({
    password: new FormControl('', Validators.required),
    newPassword: new FormControl('', Validators.required),
    newPasswordConfirmation: new FormControl('')
  }, matchValidator('newPasswordConfirmation', 'newPassword'));

  constructor(private router: Router, public shared: SharedService, private accountHttpService: AccountHttpService, private messageService: MessageService) {

  }

  async submit() {
    try {
      const formValue = this.form.value;
      await this.accountHttpService.changePassword({
        password: formValue.password,
        newPassword: formValue.newPassword
      }).toPromise();
      this.shared.notifySuccess(this.shared.res['#Password changed'], this.shared.res['#Password has been changed']);
      this.router.navigate(['/']);
    } catch (e) {

      if (e instanceof HttpErrorResponse && e.status === 400) {

        for (let error of e.error) {
          const summary = this.shared.res['#Password change failed'];
          this.messageService.add({ severity: 'error', summary, detail: error, life: 10000 });
        }

        return;
      }

      this.shared.notifyError(this.shared.res['#Password change failed'], this.shared.res['#Password change failed']);
    }
  }

}
